<script lang="ts">
  import { fade } from 'svelte/transition';
  export let name = "";
  export let placeholder = "";
  export let type = "text";
  export let value = "";
  // style

  // let classes = {
  //   class: $$props.class,
  // };
  const clear = function() {
    value = ""
  }
  let warnFlag = false
  let warnInfo = ''
  let timer = null
  export function boxWarn(info: string):void {
    clearTimeout(timer)
    warnFlag = true
    warnInfo = info
    timer = setTimeout(() => {
      warnFlag = false
      warnInfo = ''
    }, 1500)
  }
</script>

<style lang="less" src="./Input.less">
</style>

<div class={`c-input ${warnFlag && 'red-border-color'}`}>
  {#if type === 'email'}
    <input
      bind:value
      on:change
      on:keyup
      type="email"
      {name}
      {placeholder} />
  {:else if type === 'number'}
    <input
      bind:value
      on:change
      on:keyup
      type="number"
      pattern="\d*"
      {name}
      {placeholder} />
  {:else if type === 'password'}
    <input
      bind:value
      on:change
      on:keyup
      type="password"
      {name}
      {placeholder} />
  {:else if type === 'text'}
    <input
      bind:value
      on:change
      on:keyup
      type="text"
      {name}
      {placeholder} />
  {/if}
  {#if value}
  <span class="close" on:click={clear}></span>
  {/if}
  {#if warnInfo}
    <span transition:fade class="tips">{warnInfo}</span>
  {/if}
</div>